export default "__VITE_ASSET__d1886276__"